import { Assinatura } from './../assinaturas/assinatura';
import { TipoCertificado } from './../tipos_certificados/tipo_certificado';

export class Certificado{
  id: number;
  corpo: string;
  tipo: number;
  assinaturas: Assinatura[];
  verso: string = "";
  tipoCertificado: TipoCertificado;
  ativar_verso: boolean = false;
  assinatura_digital: boolean = false;

  constructor(){
    this.assinaturas = [ new Assinatura() ];
    this.tipoCertificado = new TipoCertificado();
  }
}



// WEBPACK FOOTER //
// ./src/app/certificados/certificado.ts